module.exports = __webpack_public_path__ + "static/media/kg.dfa46db1.svg";